import type { IPurchaserBrandAssociation } from "./PurchaserBrandAssociation";
import type { PurchaserConfigTemplate } from "./PurchaserConfigTemplate";

export interface IPurchaser {
  purchaserId: number;
  purchaserKey: string;
  purchaserName: string;
  purchaserIsActive: boolean;
  associatedBrandsCount?: number | null;
  associatedBrands?: IPurchaserBrandAssociation[];
  configTemplate?: PurchaserConfigTemplate | null;
}

export class Purchaser {
  private readonly _purchaserId: number;
  private readonly _purchaserKey: string;
  private readonly _purchaserName: string;
  private readonly _purchaserIsActive: boolean;
  private readonly _associatedBrandsCount: number | null;
  private readonly _associatedBrands: IPurchaserBrandAssociation[];
  private readonly _configTemplate: PurchaserConfigTemplate | null;

  constructor(props: IPurchaser) {
    this._purchaserId = props.purchaserId;
    this._purchaserKey = props.purchaserKey;
    this._purchaserName = props.purchaserName;
    this._purchaserIsActive = props.purchaserIsActive;
    this._associatedBrandsCount = props.associatedBrandsCount ?? null;
    this._associatedBrands = props.associatedBrands ?? [];
    this._configTemplate = props.configTemplate ?? null;
  }

  get purchaserId(): number {
    return this._purchaserId;
  }

  get purchaserKey(): string {
    return this._purchaserKey;
  }

  get purchaserName(): string {
    return this._purchaserName;
  }

  get purchaserIsActive(): boolean {
    return this._purchaserIsActive;
  }

  get associatedBrandsCount(): number | null {
    return this._associatedBrandsCount;
  }

  get associatedBrands(): IPurchaserBrandAssociation[] {
    return this._associatedBrands;
  }

  get configTemplate(): PurchaserConfigTemplate | null {
    return this._configTemplate;
  }

  static toJSON(purchaser: Purchaser): IPurchaser {
    return {
      purchaserId: purchaser.purchaserId,
      purchaserKey: purchaser.purchaserKey,
      purchaserName: purchaser.purchaserName,
      purchaserIsActive: purchaser.purchaserIsActive,
      associatedBrandsCount: purchaser.associatedBrandsCount,
      associatedBrands: purchaser.associatedBrands,
      configTemplate: purchaser.configTemplate,
    };
  }

  static from(props: IPurchaser): Purchaser {
    return new Purchaser(props);
  }
}
